/* eslint-disable no-console */
import axios from 'axios';

const useValidateUrl = () => {
  const KEY = process.env.REACT_APP_IFRAMELY_KEY;

  /** remove the web share permission */
  const sanitizeIframeHtml = (responsehtml) => responsehtml
    .replace(/allow="[^"]*web-share[^"]*"/g, 'allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"')
    .replace(/height:\s*0;/g, 'height: 100%;') /** Fix height issue; */
    .replace(/<iframe/g, '<iframe style="top: 0; left: 0; width: 100%; height: 100%; position: absolute; border: 0; border-radius: 4px;"');

  /** Check if the HTML contains an iframe or valid video element */
  const isIframeOrVideo = (htmlContent) => {
    const iframeRegex = /<iframe[^>]*>/i;
    const videoRegex = /<video[^>]*>/i;
    return iframeRegex.test(htmlContent) || videoRegex.test(htmlContent);
  };

  const handleValidateUrl = (
    url,
    setUrlValidationLoading,
    setPassedUrlValidation,
    setUrlValidationError,
  ) => {
    setTimeout(() => {
      axios.get(`https://iframe.ly/api/iframely?url=${encodeURIComponent(url)}&api_key=${KEY}`)
        .then(
          (res) => {
            if (res.data.html) {
            /** Sanitize the HTML before setting it */
              const sanitizedHtml = sanitizeIframeHtml(res.data.html);
              /** Only set HTML if it's an iframe or a video */
              if (isIframeOrVideo(sanitizedHtml)) {
                setUrlValidationLoading(false);
                setPassedUrlValidation(true);
              } else {
                setUrlValidationLoading(false);
                setPassedUrlValidation(false);
                setUrlValidationError('URL not valid');
              }
            }
            if (!res.data.html) {
              setUrlValidationLoading(false);
              setPassedUrlValidation(false);
              setUrlValidationError('URL not valid');
            } else if (res.error) {
              setUrlValidationLoading(false);
              setPassedUrlValidation(false);
              setUrlValidationError('URL not valid');
            }
          },
          (error) => {
            setUrlValidationLoading(false);
            setPassedUrlValidation(false);
            setUrlValidationError('URL not valid');
            console.log('url validation error:', error);
          },
        );
    }, 500);
  };

  return {
    handleValidateUrl,
  };
};

export default useValidateUrl;
